// extracted by mini-css-extract-plugin
module.exports = {"textInput":"TextInput_textInput__24Yyj","textCenter":"TextInput_textCenter__W8uS3"};